import logo from "./logo.svg";
import "./App.css";
import React from "react";

function App() {
  const d = window.Telegram?.WebApp;

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>{d ? JSON.stringify(d) : "ddddd"}</p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
